import { useQuery } from '@tanstack/react-query';
import { getTerms } from '@/services/homeService';
import { Term } from '@/types/term_type';

/**
 * Fetch all active terms
 * Cached for 24 hours
 */
export const useTerms = () => {
  return useQuery({
    queryKey: ['terms'],
    queryFn: async () => {
      const response = await getTerms();
      // Filter only active terms
      return response.filter((term: Term) => term.is_active);
    },
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
    gcTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};

/**
 * Get term by category from query result
 * @param terms - Array of terms from useTerms
 * @param category - Category to filter by
 */
export const getTermByCategory = (terms: Term[] | undefined, category: string): Term | undefined => {
  return terms?.find((term) => term.category === category);
};
